/**
 * External dependencies
 */
import { get } from 'lodash';

export const getSalesTypeId = state => get(state, 'ui.salesTypesModal.salesTypeId', "");